//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbDynamicSwiperSlide from '../../../smart-container/dynamic-swiper-slide'
import { mapGetters } from 'vuex'
export default {
  name: 'rb-mini-slider',
  components: {
    RbDynamicSwiperSlide,
  },

  data() {
    return {
      defaultConfig: {
        spaceBetween: 32,
        slidesPerView: 1,
        loop: false,
        centeredSlides: true,
        breakpoints: {
          // when window width is >= 769px
          769: {
            slidesPerView: 2.2,
          },
        },
      },
    }
  },
  computed: {
    ...mapGetters(['translation']),
    swiperSlides() {
      return this.$slots.default.filter((slot) => !!slot.tag)
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.reInitSwiper()
    })
  },
  methods: {
    reInitSwiper() {
      if (this.$refs.swiperRef?.swiper) {
        this.$refs.swiperRef.swiper.destroy()
        this.$nextTick(() => {
          this.$refs.swiperRef.$options.propsData.config.allowTouchMove = true
          this.$refs.swiperRef._setup()
        })
      }
    },
  },
}
